import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {FaTimes, FaPlus, FaGift, FaLock} from "react-icons/fa";
import {motion} from "framer-motion";
import {GoChevronDown, GoChevronUp} from "react-icons/go";
import ProfileService from "../../../services/Profile";
import {
    FaCoins,
    FaBitcoin,
    FaDollarSign,
    FaTrophy,
    FaGem,
    FaChartLine,
    FaRocket,
    FaCrown,
    FaBolt,
    FaStar,
} from "react-icons/fa6";

export default function PackageModal({onSelected, setIsPremiumSignal}) {
    const navigate = useNavigate();

    const [packages, setPackages] = useState([]);
    const [active, setActive] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState(null);

    const formatPrice = (price) => {
        if (price === "free" || price === 0) return "Free";
        if (!price) return "";

        const numPrice = typeof price === "string" ? parseInt(price) : price;
        return numPrice.toLocaleString();
    };

    const getPackageIcon = (pkg) => {
        const name = pkg?.name?.toLowerCase() || "";

        if (name.includes("golden")) {
            return {
                icon: <FaChartLine className="text-2xl text-white"/>,
                bg: "bg-gradient-to-br from-amber-400 to-orange-500",
            };
        }
        if (name.includes("silver")) {
            return {
                icon: <FaRocket className="text-2xl text-white"/>,
                bg: "bg-gradient-to-br from-blue-400 to-indigo-500",
            };
        }
        if (name.includes("platinum")) {
            return {
                icon: <FaCrown className="text-2xl text-white"/>,
                bg: "bg-gradient-to-br from-purple-400 to-pink-500",
            };
        }
        if (name.includes("scalping")) {
            return {
                icon: <FaBolt className="text-2xl text-white"/>,
                bg: "bg-gradient-to-br from-emerald-400 to-teal-500",
            };
        }

        return {
            icon: <FaStar className="text-2xl text-white"/>,
            bg: "bg-gradient-to-br from-gray-400 to-gray-500",
        };
    };

    const openModal = () => {
        setShowModal(true);
        setTimeout(() => {
            setIsOpen(true);
        }, 300);
    };

    const closeModal = () => {
        setShowModal(false);
        setTimeout(() => {
            setIsOpen(false);
        }, 300);
    };

    const handlePackageSelect = (pkg) => {
        onSelected(pkg);
        setSelectedPackage(pkg);
        closeModal();
    };

    const handleCreateNew = () => {
        closeModal();
        navigate("/createPackage");
    };

    useEffect(() => {
        if (isOpen) {
            const fetchMyPackages = async () => {
                try {
                    const res = await ProfileService.getMyPackages();
                    if (res.data.success) {
                        setPackages(res.data.data || []);
                    } else {
                        setPackages([]);
                        console.log(res.data.message_en || "No packages found");
                    }
                } catch (err) {
                    console.error("Error fetching my packages:", err);
                    setPackages([]);
                    if (err.response?.status === 401) {
                        alert("Please login again");
                    }
                }
            };

            fetchMyPackages();
        }
    }, [isOpen]);

    return (
        <>
            <div
                className="w-full min-h-[250px] bg-white shadow-lg rounded-[12px] p-6 flex flex-col justify-start items-start gap-2">
                <p className="text-[18px] leading-3 font-bold text-center h-[28px]">
                    Select Package
                </p>
                <div
                    onClick={openModal}
                    className="w-full relative mb-3 h-[60px] border-solid border-2 border-[#D1D5DB] bg-white rounded-[8px] flex flex-row px-5 justify-between gap-2 items-center"
                >
                    <p className="text-gray-500 ">
                        {selectedPackage ? selectedPackage.name : "Choose a package..."}
                    </p>
                    {isOpen ? (
                        <GoChevronUp
                            size={20}
                            className="absolute right-2 to-5 text-gray-700"
                        />
                    ) : (
                        <GoChevronDown
                            size={20}
                            className="absolute right-2 to-5 text-gray-700"
                        />
                    )}
                </div>
                <p className="text-[18px] leading-3 font-bold text-center h-[28px]">
                    Signal Type
                </p>
                <div className="flex w-[100%] gap-2">
                    <button
                        onClick={() => {
                            setActive("free");
                            setIsPremiumSignal(false);
                        }}
                        className={`
                              flex w-full text-center p-3 justify-center border-2 rounded-lg font-semibold
                              ${
                            active === "free"
                                ? "border-green-600 text-green-600 bg-green-50 hover:bg-green-100"
                                : "border-gray-200 text-gray-500 bg-gray-50 hover:bg-gray-100"
                        }
                              transition-colors
                            `}
                    >
                        <FaGift className="mr-3 mt-0.5"/>
                        Free
                    </button>
                    <button
                        onClick={() => {
                            setActive("premium");
                            setIsPremiumSignal(true);
                        }}
                        className={`
                              flex w-full text-center p-3 justify-center border-2 rounded-lg font-semibold
                              ${
                            active === "premium"
                                ? "border-amber-500 text-amber-600 bg-amber-50 hover:bg-amber-100"
                                : "border-gray-200 text-gray-500 bg-gray-50 hover:bg-gray-100"
                        }
                              transition-colors
                            `}
                    >
                        <FaCrown className="mr-3 mt-0.5"/>
                        Premium
                    </button>
                </div>
                {active === "premium" && (
                    <motion.div
                        key="premium"
                        initial={{opacity: 0, y: -35, scale: 0.98}}
                        animate={{opacity: 1, y: 0, scale: 1}}
                        exit={{opacity: 0, y: -20, scale: 0.98}}
                        transition={{
                            type: "spring",
                            stiffness: 260,
                            damping: 24,
                        }}
                        className="bg-gray-100 rounded-2xl py-10 px-6 text-center mb-4 w-full"
                    >
                        <div className="flex justify-center mb-5">
                            <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center">
                                <FaLock className="text-4xl text-gray-500"/>
                            </div>
                        </div>

                        <h3 className="text-2xl font-bold text-gray-900">
                            Subscribe to unlock
                        </h3>

                        <p className="mt-3 text-gray-500 text-lg">
                            Get access to all premium signals
                        </p>
                    </motion.div>
                )}
            </div>

            {isOpen && (
                <div className="fixed inset-0 bg-black/50 popup-overlay z-50 flex items-end">
                    <div
                        className={`bg-white rounded-t-xl w-full max-h-[80vh] overflow-hidden transform transition-transform duration-300 translate-y-0 ${
                            showModal ? "animate-slideOutToUp" : "animate-slideOutToBottom"
                        }`}
                    >
                        {/* Header */}
                        <div className="p-5 border-b border-gray-200 flex items-center justify-between">
                            <h3 className="font-bold text-lg">Select Package</h3>
                            <button onClick={closeModal} className="text-secondary">
                                <FaTimes className="text-xl"/>
                            </button>
                        </div>

                        <div className="p-5 overflow-y-auto max-h-[60vh] space-y-3">
                            <button
                                onClick={handleCreateNew}
                                className="w-full p-4 border-2 border-dashed border-primary rounded-lg text-primary font-semibold hover:bg-light transition flex items-center justify-center"
                            >
                                <FaPlus className="mr-2"/>
                                Create New Package
                            </button>

                            {/* Existing Packages */}
                            {packages.map((pkg) => {
                                const packageIcon = getPackageIcon(pkg);
                                return (
                                    <div
                                        key={pkg._id}
                                        onClick={() => handlePackageSelect(pkg)}
                                        className="package-option p-4 border border-gray-200 rounded-lg cursor-pointer hover:border-primary transition flex items-center space-x-3"
                                    >
                                        <div
                                            className={`w-12 h-12 rounded-lg flex items-center justify-center ${packageIcon.bg}`}
                                        >
                                            {pkg?.packageIcon === "coins" ? (
                                                <FaCoins className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "bitcoin" ? (
                                                <FaBitcoin className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "dollar" ? (
                                                <FaDollarSign className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "crown" ? (
                                                <FaCrown className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "rocket" ? (
                                                <FaRocket className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "trophy" ? (
                                                <FaTrophy className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "gem" ? (
                                                <FaGem className="text-2xl text-white"/>
                                            ) : pkg?.packageIcon === "star" ? (
                                                <FaStar className="text-2xl text-white"/>
                                            ) : null}
                                        </div>
                                        <div className="flex-1">
                                            <h4 className="font-semibold">{pkg.name}</h4>
                                            <p className="text-sm text-secondary">
                                                {pkg.price === "free" || pkg.price === 0
                                                    ? "Free"
                                                    : `${formatPrice(pkg.price)}/Month`}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}